// extracted by mini-css-extract-plugin
export default {"qtyContainer":"plusMinusButton-module__qtyContainer--RXKMW"};